import { useAuth } from '../lib/auth';
import { Navigate, useLocation } from 'react-router-dom';

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#020202] flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-[#ff003c] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="font-mono text-xs text-[#ff003c]">VERIFYING ADMIN ACCESS...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (!user.is_admin) {
    return (
      <div className="min-h-screen bg-[#020202] flex items-center justify-center">
        <div className="text-center">
          <p className="font-heading text-2xl font-bold text-[#ff003c] mb-2">ACCESS DENIED</p>
          <p className="font-mono text-xs text-[#999]">Admin privileges required</p>
          <a href="/dashboard" className="font-mono text-xs text-[#FF7A3D] mt-4 block hover:underline">Return to Dashboard</a>
        </div>
      </div>
    );
  }

  return children;
}
